import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Layout from './Layout';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default function Services() {
  const [targetType, setTargetType] = useState(null);
  const [items, setItems] = useState(null);
  const [search, setSearch] = useState('');
  const [err, setErr] = useState('');

  const headers = { Authorization: 'Bearer ' + localStorage.getItem('clinicToken') };

  useEffect(() => {
    axios.get(`${API}/clinic-cabinet/me`, { headers }).then(r => setTargetType(r.data.target_type));
    // eslint-disable-next-line
  }, []);

  const load = useCallback(() => {
    axios.get(`${API}/clinic-cabinet/services`, { headers, params: { search: search || undefined } })
      .then(r => setItems(r.data.items));
    // eslint-disable-next-line
  }, [search]);

  useEffect(() => {
    const t = setTimeout(load, 200);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [load]);

  const toggle = async (svc) => {
    setErr('');
    try {
      if (svc.selected) {
        await axios.delete(`${API}/clinic-cabinet/services/${svc.id}`, { headers });
      } else {
        await axios.post(`${API}/clinic-cabinet/services/${svc.id}`, {}, { headers });
      }
      setItems(items.map(it => it.id === svc.id ? { ...it, selected: !it.selected } : it));
    } catch (e) { setErr(e?.response?.data?.detail || 'Не удалось сохранить'); }
  };

  return (
    <Layout>
      <h1 style={s.h1}>Услуги</h1>
      <div style={s.hint}>
        Отметьте услуги, которые физически оказываются {targetType === 'network' ? 'в вашей сети (хотя бы в одном учреждении)' : 'в вашей клинике'} —
        это помогает врачам находить нужную {targetType === 'network' ? 'сеть' : 'клинику'} при добавлении пациента.
        {targetType === 'network' && ' Уточнять, в каком именно учреждении сети есть услуга, врач или пациент будет напрямую — например, через ваш колл-центр.'} {' '}
        Список — общий справочник Refero; если нужной услуги нет, напишите в техподдержку.
      </div>

      <input style={s.search} placeholder="Поиск по названию услуги" value={search}
        onChange={e => setSearch(e.target.value)} />

      {err && <div style={s.err}>{err}</div>}

      <div style={s.tableCard}>
        {items === null ? (
          <div style={s.empty}>Загрузка…</div>
        ) : items.length === 0 ? (
          <div style={s.empty}>Ничего не найдено</div>
        ) : items.map(svc => (
          <label key={svc.id} style={s.row}>
            <input type="checkbox" checked={svc.selected} onChange={() => toggle(svc)} style={s.checkbox} />
            <span style={svc.selected ? s.rowLabelActive : s.rowLabel}>{svc.name}</span>
          </label>
        ))}
      </div>
    </Layout>
  );
}

const s = {
  h1: { color: '#1B2B4B', fontSize: 28, fontWeight: 800, margin: '0 0 12px' },
  hint: { color: '#64748b', fontSize: 13, lineHeight: 1.5, marginBottom: 20, maxWidth: 640 },
  search: { background: '#F6F8FB', border: '1px solid #d7dee8', borderRadius: 10, padding: '10px 14px', fontSize: 14, color: '#1B2B4B', outline: 'none', width: '100%', maxWidth: 360, marginBottom: 16, boxSizing: 'border-box' },
  err: { color: '#dc2626', fontSize: 13, marginBottom: 10 },
  tableCard: { background: '#fff', borderRadius: 16, padding: '8px 8px', boxShadow: '0 4px 16px rgba(27,43,75,0.06)' },
  row: { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid #f4f7fb', cursor: 'pointer' },
  checkbox: { width: 18, height: 18, accentColor: '#2EC4B6', cursor: 'pointer', flexShrink: 0 },
  rowLabel: { color: '#475569', fontSize: 14 },
  rowLabelActive: { color: '#1B2B4B', fontSize: 14, fontWeight: 600 },
  empty: { color: '#94a3b8', textAlign: 'center', padding: '32px 0', fontSize: 14 },
};
